import React from "react";
import PropTypes from "prop-types";
import goToLinkInternally from "../common/helpers/goToLinkInternally";

const Pagination = (props) => {
  const { curPage, maxPage, pagesAround, getPageLink, useLink } = props;
  const getPaginationArray = (_curPage, _maxPage, _pagesAround) => {
    const pages = [];
    let added = 0;
    let counter = _curPage - _pagesAround;
    while (added < pagesAround * 2 + 1) {
      if (counter > _maxPage) break;
      if (counter > 0) {
        pages.push(counter);
        added += 1;
      }
      counter += 1;
    }
    // Go reverse if and fill up any remaining in case we're close to the last page
    if (added < _pagesAround * 2 + 1) {
      const minAdded = pages[0];
      const remaining = minAdded - (_pagesAround * 2 + 1 - added);
      for (let i = minAdded - 1; i >= remaining; i--) {
        if (i <= 0) break;
        pages.unshift(i);
      }
    }
    if (pages[0] > 1) {
      if (pages[0] > 2) {
        pages.unshift("...");
      }
      pages.unshift(1);
    }
    if (pages[pages.length - 1] < _maxPage) {
      if (pages[pages.length - 1] < _maxPage - 1) {
        pages.push("...");
      }
      pages.push(_maxPage);
    }

    return pages;
  };
  const pages = getPaginationArray(curPage, maxPage, pagesAround);
  return curPage !== undefined && maxPage > 1 && pagesAround !== undefined ? (
    <div className="tw-text-center">
      <div style={{ fontSize: "1.1rem" }}>PAGES</div>
      <span className="tw-mr-8">
        {curPage > 1 &&
          (useLink ? (
            <a
              href={getPageLink(curPage - 1)}
              onClick={(e) => goToLinkInternally(getPageLink(curPage - 1), e)}
              data-tooltip={curPage > 1 ? "Previous page" : ""}
            >
              <i className="fa fa-chevron-left" />
            </a>
          ) : (
            <a
              onClick={() => getPageLink(curPage - 1)}
              data-tooltip={curPage > 1 ? "Previous page" : ""}
            >
              <i className="fa fa-chevron-left" />
            </a>
          ))}
        {curPage === 1 && (
          <i className="fa fa-chevron-left varsome-text-muted" />
        )}
      </span>
      {pages.map((p, i) => {
        if (p === "..." || p === curPage) {
          return (
            <strong key={i} style={{ margin: "0 0.8rem", fontSize: "1.1rem" }}>
              {p}
            </strong>
          );
        }
        return useLink ? (
          <a
            key={i}
            style={{ margin: "0 0.8rem" }}
            href={getPageLink(p)}
            onClick={(e) => goToLinkInternally(getPageLink(p), e)}
          >
            {p}
          </a>
        ) : (
          <a
            key={i}
            style={{ margin: "0 0.8rem" }}
            onClick={() => getPageLink(p)}
          >
            {p}
          </a>
        );
      })}
      <span className="tw-mr-8">
        {curPage < maxPage &&
          (useLink ? (
            <a
              href={getPageLink(curPage + 1)}
              onClick={(e) => goToLinkInternally(getPageLink(curPage + 1), e)}
              data-tooltip={curPage < maxPage ? "Next page" : ""}
            >
              <i className="fa fa-chevron-right" />
            </a>
          ) : (
            <a
              onClick={() => getPageLink(curPage + 1)}
              data-tooltip={curPage < maxPage ? "Next page" : ""}
            >
              <i className="fa fa-chevron-right" />
            </a>
          ))}
        {curPage === maxPage && (
          <i className="fa fa-chevron-right varsome-text-muted" />
        )}
      </span>
    </div>
  ) : null;
};

Pagination.propTypes = {
  curPage: PropTypes.number.isRequired,
  maxPage: PropTypes.number.isRequired,
  pagesAround: PropTypes.number.isRequired,
  getPageLink: PropTypes.func.isRequired,
  useLink: PropTypes.bool.isRequired,
};

export default Pagination;
